import { YeatiesRefusedPanel } from "@/features/card/components/OnboardingModal/OnBoardingModalElements/OnboardingModalSteps/YeatiesConsent/YeatiesRefusedPanel";
import { YEATIES_ACCEPTED_MESSAGE } from "@/features/card/configs/yeatiesConsent.config";
import type { YeatiesConsent } from "@/features/purchasePoints";
import { useOnboardingContext } from "@/shared/context/OnboardingContext";
import { P } from "@/shared/ui/typographies/paragraph";

type CardActivationSuccessSlideContentProps = { consent: YeatiesConsent | null };

export const CardActivationSuccessSlideContent = ({ consent }: CardActivationSuccessSlideContentProps) => {
  const { activatingCardId } = useOnboardingContext();
  const isPending = activatingCardId !== null;

  return (
    <>
      <P className="text-base space-y-4 animate-fade-in text-center text-pretty">
        {isPending
          ? "Votre carte Yeati va être activée d'un instant à l'autre..."
          : "Votre carte Yeati est maintenant active et prête à être utilisée."}
      </P>
      {consent === "accepted" && (
        <P className="mt-6 animate-fade-in text-center text-pretty" data-testid="yeaties-accepted-message">
          {YEATIES_ACCEPTED_MESSAGE}
        </P>
      )}
      {consent === "refused" && <YeatiesRefusedPanel />}
    </>
  );
};
